import { render, staticRenderFns } from "./DefaultTabsLayout.vue?vue&type=template&id=d5c80a02&scoped=true&"
import script from "./DefaultTabsLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultTabsLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTabsLayout.vue?vue&type=style&index=0&id=d5c80a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c80a02",
  null
  
)

export default component.exports